var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMask)?_c('div',{staticClass:"mask",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }!_vm.isWeChat && _vm.toggleView}}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }